import 'iframe-lightbox';

export default () => {
    [].forEach.call(document.getElementsByClassName("iframe-lightbox-link"), (el) => {
        if (!el.classList.contains("is-binded")) {
            el.lightbox = new IframeLightbox(el); // eslint-disable-line
            el.classList.add("is-binded");
        }
    });
};



// WEBPACK FOOTER //
// ./src/widgets/VideoLightbox.js